import { render, staticRenderFns } from "./topDivision.vue?vue&type=template&id=19d7a56b&"
import script from "./topDivision.vue?vue&type=script&lang=js&"
export * from "./topDivision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports